import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';
import { useMatrix } from '../contexts/MatrixContext';
import TopPerformers from '../components/TopPerformers';
import ProductsBrowser from '../components/ProductsBrowser';
import TradeTracker from '../components/TradeTracker';
import './GuruDashboard.css';

function GuruDashboard() {
  const { slug } = useParams();
  // Default to "lance" if no slug provided (for root path "/")
  const guruSlug = slug || 'lance';
  const [guru, setGuru] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('dashboard'); // 'dashboard', 'tracker', or 'products'
  const { setIsTradeTrackerActive } = useMatrix();

  useEffect(() => {
    const fetchGuruData = async () => {
      try {
        setLoading(true);
        const guruRes = await api.get(`/gurus/${guruSlug}`);
        setGuru(guruRes.data);
        setLoading(false);
      } catch (err) {
        setError(`Failed to load guru data: ${err.message}`);
        setLoading(false);
      }
    };

    fetchGuruData();
  }, [guruSlug]);

  // Update matrix visibility when tab changes
  useEffect(() => {
    setIsTradeTrackerActive(activeTab === 'tracker');
  }, [activeTab, setIsTradeTrackerActive]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!guru) return <div className="error">Guru not found</div>;

  return (
    <div className="guru-dashboard">
      <div className="guru-header-container">
        <div className="guru-header">
          <div className="guru-info">
            <img src="/performance-grid-logo.png" alt="Lance's Performance Grid" className="guru-title-logo" style={{height: '280px', width: 'auto'}} />
          </div>
        </div>

        {/* Tab Selector inside header container */}
        <div className="tab-selector">
          <button
            className={`tab-button ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            <span className="tab-icon">📊</span>
            <span className="tab-label">Dashboard</span>
          </button>
          <button
            className={`tab-button ${activeTab === 'tracker' ? 'active' : ''}`}
            onClick={() => setActiveTab('tracker')}
          >
            <span className="tab-icon">📈</span>
            <span className="tab-label">Trade Tracker</span>
          </button>
          <button
            className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
            onClick={() => setActiveTab('products')}
          >
            <span className="tab-icon">🎯</span>
            <span className="tab-label">All Products</span>
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'dashboard' && (
          <div className="rankings-section">
            <TopPerformers guruSlug={guruSlug} />
          </div>
        )}

        {activeTab === 'tracker' && (
          <div className="tracker-section">
            <TradeTracker guruSlug={guruSlug} />
          </div>
        )}

        {activeTab === 'products' && (
          <ProductsBrowser guruSlug={guruSlug} />
        )}
      </div>
    </div>
  );
}

export default GuruDashboard;
